import { cn } from "@workspace/ui/lib/utils";

export function Header({
  title,
  description,
  descriptionClassName,
}: {
  title: string;
  description?: string;
  descriptionClassName?: string;
}) {
  return (
    <div className="flex flex-col gap-3">
      <h1
        className="text-primary title-24 md:title-32"
        dangerouslySetInnerHTML={{ __html: title }}
        id="question-title"
        data-testid="question-title"
        ></h1>
      {description && (
        <p
          className={cn(
            "text-muted-foreground title-14 font-normal",
            descriptionClassName
          )}
          id="question-sub-title"
          data-testid="question-sub-title"
          >
          {description}
        </p>
      )}
    </div>
  );
}
